import { PropsWithChildren } from "react";
import { StudentFormData, useStudentForm } from "../StudentDataFormProvider";
import { Stack, Typography } from "@mui/material";

type Props = {
  fieldName: keyof StudentFormData;
  label?: string;
  maxLength?: number;
  required?: boolean;
};

export const CheckboxField = ({ fieldName, label, required = false }: PropsWithChildren<Props>) => {
  const {
    register,
    formState: { errors },
  } = useStudentForm();
  return (
    <Stack gap={"0.25rem"}>
      <Stack direction={"row-reverse"} gap={"1rem"} justifyContent={"flex-end"}>
        {label && <label htmlFor={fieldName}>{label}</label>}
        <input type="checkbox" {...register(fieldName, { required })}></input>
      </Stack>
      {errors[fieldName] && (
        <Typography variant="caption" sx={{ color: "red" }}>
          This field is required
        </Typography>
      )}
    </Stack>
  );
};
